module.exports = __webpack_public_path__ + "static/media/05.785fd025.svg";